import { useEffect, useState } from "react";
import Lenis from "lenis";
import "@/App.css";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Manifesto from "@/components/landing/Manifesto";
import GrowthPath from "@/components/landing/GrowthPath";
import Engine from "@/components/landing/Engine";
import Privacy from "@/components/landing/Privacy";
import Simulator from "@/components/landing/Simulator";
import HowItWorks from "@/components/landing/HowItWorks";
import AppGallery from "@/components/landing/AppGallery";
import Footer from "@/components/landing/Footer";

export default function App() {
  const [theme, setTheme] = useState("light");

  useEffect(() => {
    const lenis = new Lenis({ autoRaf: true, duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    return () => {
      lenis.destroy();
      window.__lenis = null;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      data-theme={theme}
      data-testid="app-root"
      className="relative min-h-screen bg-[var(--sp-bg)] text-[var(--sp-fg)] font-body antialiased"
    >
      <div className="noise-overlay" aria-hidden="true" />
      <Header theme={theme} onToggleTheme={() => setTheme((t) => (t === "dark" ? "light" : "dark"))} />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <GrowthPath />
        <HowItWorks />
        <AppGallery />
        <Engine />
        <Privacy />
        <Simulator />
      </main>
      <Footer />
    </div>
  );
}
